import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useChangelog, useInformationMessage } from 'hooks';
import { colors } from 'theme';
import InfoIcon from 'components/Icons/InfoIcon';
import { Routes } from 'routes';

const useStyles = makeStyles({
  backgroundImage: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    height: '50vh',
  },
  title: {
    fontSize: '3.8rem',
  },
  subtitle: {
    fontSize: '2.2rem',
  },
  firstUpdateMessageBox: {
    marginTop: '60px',
  },
  updateMessageBox: {
    marginTop: '17px',
  },
  infoIcon: {
    marginRight: '13px',
    color: colors.neutral800,
  },
  firstUpdateText: {
    fontWeight: 600,
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    color: colors.neutral800,
  },
  updateText: {
    marginLeft: '37px',
    fontWeight: 600,
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    color: colors.neutral800,
  },
});

export const HomePage: React.FC<any> = () => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'homepage' });
  const N_LAST_DAYS = 3;

  const dateThreeDaysAgo = new Date();
  dateThreeDaysAgo.setDate(dateThreeDaysAgo.getDate() - N_LAST_DAYS);
  const { value: changelogs } = useChangelog(new Date(), dateThreeDaysAgo);
  const { value: informationMessages } = useInformationMessage();

  if (informationMessages) {
    informationMessages.sort((a, b) => {
      const remainingTimeA = new Date(a.endDate).getTime() - new Date().getTime();
      const remainingTimeB = new Date(b.endDate).getTime() - new Date().getTime();
      return remainingTimeA - remainingTimeB;
    });
  }

  const topFivePermanentMessages = informationMessages?.slice(0, 5);

  const hasChangelogs = changelogs && changelogs.length > 0;
  const hasMessages = topFivePermanentMessages && topFivePermanentMessages.length > 0;

  return (
    <>
      <Box display="flex" flexGrow={1} justifyContent="center" flexDirection="column" marginLeft="10vw">
        <Typography variant="h1" color="primary" className={classes.title}>
          {t('title')}
          <Typography color="textPrimary" display="block" variant="inherit" className={classes.subtitle}>
            {t('subtitle')}
          </Typography>
          <>
            {hasChangelogs && (
              <Box className={classes.firstUpdateMessageBox}>
                <Typography color="textPrimary" className={classes.firstUpdateText}>
                  {hasChangelogs && <InfoIcon width={24} height={24} className={classes.infoIcon} />}
                  {hasChangelogs && (
                    <Trans i18nKey="homepage.hasNewChangelog">
                      La version d'e-tem a été mise à jour ! Pour en savoir plus sur vos nouvelles fonctionnalités
                      <Link to={Routes.InfoPage} target="_blank">
                        cliquez ici
                      </Link>
                    </Trans>
                  )}
                </Typography>
              </Box>
            )}
            {hasMessages &&
              topFivePermanentMessages.map((message, index) => (
                <Box
                  className={index === 0 && !hasChangelogs ? classes.firstUpdateMessageBox : classes.updateMessageBox}
                  key={index}
                >
                  <Typography
                    color="textPrimary"
                    className={index === 0 && !hasChangelogs ? classes.firstUpdateText : classes.updateText}
                  >
                    {index === 0 && !hasChangelogs && <InfoIcon width={24} height={24} className={classes.infoIcon} />}
                    {message.message}
                  </Typography>
                </Box>
              ))}
          </>
        </Typography>
      </Box>
      <img className={classes.backgroundImage} alt="" src="/bg-pattern.png" />
    </>
  );
};

export default HomePage;
